var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders, OWNCLOUD_IMPORT_TRIGGER_TIMEOUT_MS, } from "../utils/apiUtils";
import { API_PATHS } from "../types/apiPaths";
export var fetchActiveTitleImport = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.TITLES_DATA_IMPORT_ACTIVE, {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                _a = _b.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var uploadTitleFile = function (kyInstance, file) { return __awaiter(void 0, void 0, void 0, function () {
    var formData, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formData = new FormData();
                formData.append("file", file);
                return [4 /*yield*/, kyInstance.post(API_PATHS.TITLES_DATA_IMPORT_UPLOAD, {
                        body: formData,
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Upload error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
export var startTitleImportFromFile = function (kyInstance, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchParams = new URLSearchParams();
                searchParams.set("fileName", fileName);
                return [4 /*yield*/, kyInstance.get(API_PATHS.TITLES_DATA_IMPORT_IMPORT_FROM_FILE, {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Start import error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
export var fetchTitleImportStatus = function (kyInstance, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchParams = new URLSearchParams();
                searchParams.set("fileName", fileName);
                return [4 /*yield*/, kyInstance.get(API_PATHS.TITLES_DATA_IMPORT_STATUS, {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch status error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var fetchTitleImportEvents = function (kyInstance, params) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchParams = new URLSearchParams();
                searchParams.set("fileName", params.fileName);
                searchParams.set("severity", params.severity);
                searchParams.set("page", String(params.page));
                searchParams.set("size", String(params.size));
                if (params.query && params.query.trim().length > 0) {
                    searchParams.set("q", params.query.trim());
                }
                return [4 /*yield*/, kyInstance.get(API_PATHS.TITLES_DATA_IMPORT_EVENTS, {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch events error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var deleteTitleFile = function (kyInstance, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchParams = new URLSearchParams();
                searchParams.set("fileName", fileName);
                return [4 /*yield*/, kyInstance.get(API_PATHS.TITLES_DATA_IMPORT_DELETE_FILE, {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Delete file error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
export var fetchOwnCloudTitleFiles = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get(API_PATHS.TITLES_DATA_IMPORT_OWNCLOUD_FILES, {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
        }
    });
}); };
/**
 * Triggers a background title import from an OwnCloud file.
 *
 * The backend responds `202 Accepted` immediately and performs the download and
 * import asynchronously; the real progress and outcome are read from
 * {@link fetchTitleImportStatus}. A generous timeout is used so a slow gateway
 * relaying the immediate 202 does not trip ky's default 10s abort.
 *
 * @param kyInstance the tenant-scoped ky client
 * @param fileName the OwnCloud file to import
 */
export var importTitlesFromOwnCloud = function (kyInstance, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.TITLES_DATA_IMPORT_OWNCLOUD_IMPORT, {
                    json: { fileName: fileName },
                    headers: getHeaders(),
                    timeout: OWNCLOUD_IMPORT_TRIGGER_TIMEOUT_MS,
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
